import * as R from 'ramda'
import {
  EVENT_MESSAGE_ACTION,
  EventMessageActionPayload,
} from '@weblite/ts-action/message'
import debounce from 'lodash.debounce'
import { serverSub } from '$func/subscription'
import { messageActionStorage } from '$logic/message-action/message-action.storage'
import { getRoom } from '$logic/room'
import { getUser, setUserStatusTemporaryOnline } from '$logic/users'

export const RECEIVE_ACTION_TIME_OUT = 3000
export const ERASE_ACTION_TIME_OUT = 4000

const insertDebounceList: Record<string, () => any> = {}
const eraseDebounceList: Record<string, () => any> = {}

const debounceKeyGenerator = ({
  roomId,
  userId,
  action,
}: EventMessageActionPayload) => R.join('', [roomId, userId, action])

const onEventReceived = (messageAction: EventMessageActionPayload) => {
  const debounceKey = debounceKeyGenerator(messageAction)
  if (R.has(debounceKey, insertDebounceList)) {
    insertDebounceList[debounceKey]()
  } else {
    const newDebounce = debounce(
      () => messageActionStorage.insertMessageAction(messageAction),
      RECEIVE_ACTION_TIME_OUT,
      { leading: true, trailing: false },
    )
    ;(insertDebounceList as any)[debounceKey] = newDebounce
    newDebounce()
  }
}

const eraseEvent = (messageAction: EventMessageActionPayload) => {
  const debounceKey = debounceKeyGenerator(messageAction)
  if (R.has(debounceKey, eraseDebounceList)) {
    eraseDebounceList[debounceKey]()
  } else {
    const newDebounce = debounce(
      () => messageActionStorage.removeMessageAction(messageAction),
      ERASE_ACTION_TIME_OUT,
      { leading: false, trailing: true },
    )
    ;(eraseDebounceList as any)[debounceKey] = newDebounce

    newDebounce()
  }
}

serverSub.subscribe(
  EVENT_MESSAGE_ACTION,
  async (messageAction: EventMessageActionPayload) => {
    const { roomId, userId } = messageAction
    const room = await getRoom(roomId)
    if (!room) return
    if (room.type === 'PV') {
      const user = await getUser(userId)
      if (user.isBlocked) return
    }
    setUserStatusTemporaryOnline(userId)
    onEventReceived(messageAction)
    eraseEvent(messageAction)
  },
)
